export enum QRCodeScreenTypes {
  SHOW_QR_CODE = 'SHOW_QR_CODE',
  SHARE_QR_CODE = 'SHARE_QR_CODE',
  DOWNLOAD_QR_CODE = 'DOWNLOAD_QR_CODE',
  RE_GENERATE_QR_CODE = 'RE_GENERATE_QR_CODE',
  QR_CODE_FAQ = 'QR_CODE_FAQ',
}

export enum QRCodeContentNavigationActions {
  CLOSE = 'CLOSE',
  BACK = 'BACK',
  JUMP_SCREEN = 'JUMP_SCREEN',
  JUMP_LAST_VISITED_SCREEN = 'JUMP_LAST_VISITED_SCREEN',
}

export enum QRCodeContentLocalStorageKeys {
  QR_CODE_REGENERATE_DONT_SHOW_AGAIN = 'courierQRCodeRegenerateDontShowAgain',
}

export interface IQRCodeContentCommonProps {
  onNavigate?: (
    action: QRCodeContentNavigationActions,
    targetScreen?: QRCodeScreenTypes,
    additionalParameters?: any
  ) => void;
  popupView?: boolean;
  bottomSheetView?: boolean;
  additionalParameters?: any;
}
